import { Component } from '@angular/core';

@Component({
  selector: 'app-pagamento-fallito',
  imports: [],
  templateUrl: './pagamento-fallito.html',
  styleUrl: './pagamento-fallito.css'
})
export class PagamentoFallito {

}
